const adminMenuItems = [{
    name: "จัดการผลหวย",
    icon: "ApertureIcon",
    submenu: [{
        url: '/',
        name: 'ผลหวยรายวัน',
        slug: 'admin-lotto-results'
      },
      {
        url: '/add-drawdate',
        name: 'เพิ่มงวดหวย',
        slug: 'admin-add-drawdate'
      }
    ]
  }
]

export { adminMenuItems }
